import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

const JEA_YEAR = 2025;

export const defaultState = {
  jea2025: {
    list: [],
    listLoading: false,
  },
};

export const mutations = {
  JEA2025_SET_LIST(state, list) {
    state.jea2025.list = list;
  },
  JEA2025_SET_LIST_LOADING(state, isLoading) {
    state.jea2025.listLoading = isLoading;
  },
};

export const getters = {
  getJea2025List: state => state.jea2025.list,
  getJea2025ListIsLoading: state => state.jea2025.listLoading,
};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  callJea2025Approve({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/approve`, data)
      .then(result => result.data);
  },
  // eslint-disable-next-line no-unused-vars
  callJea2025Trigger({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/trigger`, data)
      .then(result => result.data);
  },
  fetchJea2025List({ commit }, filterByStatus) {
    commit('JEA2025_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea?filter_by_status=${filterByStatus}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { jeas } = response;
          commit('JEA2025_SET_LIST_LOADING', false);
          commit('JEA2025_SET_LIST', jeas);
        });
      })
      .catch((error) => {
        commit('JEA2025_SET_LIST_LOADING', false);
        commit('JEA2025_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchJea2025All({ dispatch }, filterByStatus) {
    dispatch('fetchJea2025List', filterByStatus);
  },
  // eslint-disable-next-line no-unused-vars
  fetchJea2025DownloadPdf({ commit }, requestData) {
    const { id } = requestData;

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/pdf/${id}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
};

const jea2025 = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default jea2025;



// WEBPACK FOOTER //
// ./src/store/payout/jea2025.js